import { render } from "./serviceSim.vue?vue&type=template&id=5990a17c"
import script from "./serviceSim.vue?vue&type=script&lang=js"
export * from "./serviceSim.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__